import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import { sortControlStyles } from "@dana/Overrides/Widgets/MyLists/MyListsSortControl";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

sortControlStyles.toggleFilterButton = mergeToNew(sortControlStyles.toggleFilterButton, {
    css: css`
        background: transparent;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
            border: none;
            background: transparent;
        }
    `,
});

sortControlStyles.wrapper = mergeToNew(sortControlStyles.wrapper, {
    css: css`
        [data-test-selector="popoverOverflowTrigger"] {
            background: transparent;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
                border: none;
                background: transparent;
            }
        }
    `,
});

sortControlStyles.sortByOverflowMenu = mergeToNew(sortControlStyles.sortByOverflowMenu, {
    cssOverrides: {
        menuItem: css`
            &:hover {
                background: ${themeColors.primary.danaBlue};
                color: ${themeColors.primary.white};
            }
        `,
    },
});
